import { useOutletContext } from 'react-router';
import type { PublicTenant } from './schemas';

export interface TenantContext { tenant: PublicTenant }

export function useTenant(): PublicTenant {
  return useOutletContext<TenantContext>().tenant;
}
